import { MondayBoard } from "shared/integrations/mapper";
import { LiveIntegrationFilter, LiveIntegrationValue } from "./utils";
import { useState } from "react";
import { useBoardTasks } from "frontend/hooks/use-board-integrations";
import style from "./liveIntegrationPicker.module.css";
import { LiveIntegrationBoardPicker } from "./liveIntegrationBoardPicker";
import { LiveIntegrationFiltersPicker } from "./liveIntegrationFiltersPicker";
import { MondayIntegrationType } from "shared/integrations/integration";

export function LiveIntegrationPicker({
  integrationId,
  filters,
  documentId,
  onChange,
}: {
  integrationId?: string;
  filters: LiveIntegrationFilter[];
  documentId?: string;
  onChange: (newValue: LiveIntegrationValue) => void;
}) {
  const { mondayIntegration, addMondayIntegration, getBoardIntegrationConfig } = useBoardTasks(documentId);
  const [selectedBoard, setSelectedBoard] = useState<MondayBoard | null>(null);
  const [selectedFilters, setSelectedFilters] = useState<LiveIntegrationFilter[]>(filters);
  const [savingBoard, setSavingBoard] = useState(false);

  const selectedBoardId =
    integrationId && (selectedBoard?.id ?? getBoardIntegrationConfig(integrationId)?.config.boardId);

  async function onSelectBoard(board: MondayBoard | null) {
    if (!board) {
      return; // Selection cannot be cleared
    }

    if (!mondayIntegration) {
      return;
    }
    if (board.id === selectedBoardId) {
      setSelectedBoard(board);
      return;
    }
    setSavingBoard(true);
    // TODO: find another integration with the same boardId
    const integrationId = await addMondayIntegration(
      board.id,
      mondayIntegration.id,
      board.columns,
      MondayIntegrationType.live
    );
    setSavingBoard(false);
    setSelectedBoard(board);
    setSelectedFilters([]);
    onChange({ integrationId, filters: [] });
  }

  function changeFilters(filters: LiveIntegrationFilter[]) {
    setSelectedFilters(filters);
    onChange({ integrationId, filters });
  }

  return (
    <div className={style.container}>
      <div className={style.header}>Create live view of:</div>
      <div className={style.boardContainer}>
        <LiveIntegrationBoardPicker
          mondayIntegrationId={mondayIntegration.id}
          selectedBoardId={selectedBoardId}
          onSelectBoard={onSelectBoard}
        />
      </div>
      {savingBoard && (
        <div className={style.savingBoard}>
          Integrating your board...
          <span className={style.loader} />
        </div>
      )}
      {selectedBoard && !savingBoard && (
        <div className={style.filtersContainer}>
          <LiveIntegrationFiltersPicker
            filters={selectedFilters}
            columns={selectedBoard.columns}
            onSelectFilters={changeFilters}
            readonly={false}
          />
        </div>
      )}
    </div>
  );
}
